import React from 'react';
import { Check, X } from 'react-feather';

export const TickCross = ({ bool }) => bool ? <Check color="green" /> : <X color="red" />;



// WEBPACK FOOTER //
// ./src/components/TickCross.js